import { makeStyles } from "@/compat/muiStyles";
import { useState } from "react";
import ImproveScoreDialog from "./dialogs/ImproveScoreDialog";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.spacing(1),
    backgroundColor: "#fff",
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
  title: {
    fontWeight: 700,
    paddingBottom: theme.spacing(1),
  },
  text: {
    fontSize: "0.75rem",
  },
  button: {
    padding: theme.spacing(0),
    marginTop: theme.spacing(1),
    backgroundColor: "transparent",
    border: "none",
    fontWeight: 700,
    fontSize: "0.75rem",
    color: theme.palette.secondary.main,
    "&:hover": {
      cursor: "pointer",
    },
    width: "fit-content",
  },
}));

export default function ImproveScoreInfo() {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <ImproveScoreDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <div className={classes.container}>
        <div className={classes.title}>
          How can you improve your SafetyNest Score?
        </div>
        <div className={classes.text}>
          There are three main reasons to manage health and safety, legal, moral
          and financial. Your score is no different, SafetyNest is built to
          support each of these reasons.
        </div>
        <div className={classes.button} onClick={() => setDialogOpen(true)}>
          Improve your SafetyNest Score
        </div>
      </div>
    </>
  );
}
